export default {

        "id": "321",
        "group": "0",
        "parent_id": "321",
        "animate": "0",
        "billable": "0",
        "batch_price": "1",
        "status": "0",
        "title": {
            "hu": "Stéges fel\u00e9p\u00edtm\u00e9ny összekötő",
        },
        "hasOptions": 0,
        "hidden": 1,
        "readOnlyTitle": 1,

};
